<template>
  <!-- 修改应用名称对话框 -->
  <el-dialog title="编辑应用"
             :visible.sync="paramShow.editAppVisible"
             :close-on-click-modal="false"
             width="50%">
    <el-form :model="editAppForm"
             :rules="editAppFormRules"
             ref="editAppFormRef"
             label-width="100px"
             @submit.native.prevent>
      <el-form-item label="应用名称"
                    prop="name">
        <el-input v-model="editAppForm.name"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="paramShow.editAppVisible = false;
      editAppForm.name=editItem.name">取 消</el-button>
      <el-button type="primary"
                 @click="editAppInfo">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>

import http from '@/http/index.js'

export default {
  props: ['paramShow', 'editItem'],
  data() {
    // 验证应用名称是否重复
    var checkAppName = async (rule, value, cb) => {
      // 向后端请求所有用户名称
      if (this.editItem.name === value) {
        return cb(new Error('应用名称无更改'));
      }
      const res = await http.app.getAppList();
      const allAppname = res.map((item) => {
        return item.name;
      });
      let isRepeat = allAppname.some((item) => {
        return item === value;
      });
      if (isRepeat) {
        // 合法的用户名
        return cb(new Error('应用名称已被占用，请使用其他名称'));
      }
      return cb();
    };
    return {
      editAppForm: {
        name: null,
        appId: null
      },
      editAppFormRules: {
        name: [
          { required: true, message: '请输入应用名称', trigger: 'blur' },
          { validator: checkAppName, trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    editAppInfo() {
      // 修改应用名称
      this.$refs.editAppFormRef.validate(async (valid) => {
        if (!valid) return;
        // 发起修改应用名称请求
        await http.app.edit({
          name: this.editAppForm.name,
          id: this.editAppForm.appId
        });
        // 关闭对话框
        this.paramShow.editAppVisible = false;
        // 刷新数据列表
        this.$emit('updateList');
        // 提示修改成功
        this.$message.success('更新应用名称成功！');
      });
    }
  },
  created() {
    this.editAppForm.name = this.editItem.name;
    this.editAppForm.appId = this.editItem.appId;
  }
};
</script>
